import { render, staticRenderFns } from "./new-master.vue?vue&type=template&id=175f22b4&scoped=true&"
import script from "./new-master.vue?vue&type=script&lang=js&"
export * from "./new-master.vue?vue&type=script&lang=js&"
import style0 from "./new-master.vue?vue&type=style&index=0&id=175f22b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f22b4",
  null
  
)

export default component.exports